import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericFilter } from 'shared';
import { BookedProjectModules } from 'shared';
import { AvailableModulesItemCount } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'add-project-modules-dialog',
    templateUrl: './add-project-modules-dialog.component.html',
    styleUrls: ['./add-project-modules-dialog.component.scss'],
    standalone: false
})
export class AddProjectModulesDialogComponent implements OnInit {

  modulesForm!: UntypedFormGroup;
  availableModules: AvailableModulesItemCount[] = [];
  tenantAvailableModules: AvailableModulesItemCount[] = [];
  bookedModules: BookedProjectModules[] = [];
  savedata: BookedProjectModules[] = [];
  isModulesLoaded: boolean = false;
  isCreateFormCalled: boolean = false;

      get modules(): UntypedFormArray {
    return this.modulesForm.get('modules') as UntypedFormArray;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    public _dialogRef: MatDialogRef<AddProjectModulesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BookedProjectModules[],
    public translate: TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService,
    //private oauthService: OAuthServiceService

  ) {

  }
   ngOnInit(): void {
    this.savedata = this.data; //vorher gebuchte Module, für Abbruch speichern
    this.isCreateFormCalled = (this.data && this.data.length > 0) ? false : true;
    this.tenantService.GetAvailableModules(this.tenantService.currentTenantName, new GenericFilter()).subscribe({
      next: (modules) => {
        console.log("-------> add-project-modules-dialog available modules: ", modules)
        console.log("-------> add-project-modules-dialog booked modules: ", this.data)
        if (!modules || modules.length === 0) { 
          this.notificationService.info(`${this.translate.data["INFO"]}`, 'Keine verfügbaren Module gefunden');
          this.isModulesLoaded = true;
          this.createForm();
          return; 
        }

        this.tenantService.getTenant(this.tenantService.currentTenantId).subscribe({
          next: (tenantDto) => {
            const json = tenantDto.additionalModules;
            console.log("------------> add-project-modules-dialog tenant.additionalModules = ", tenantDto.additionalModules);
            if (json)
              this.tenantAvailableModules = JSON.parse(json);

            console.log("------------> add-project-modules-dialog tenant availableModules = ", this.tenantAvailableModules);
            this.tenantAvailableModules.forEach(tam => {
              console.log("------------> add-project-modules-dialog checking tam.moduleId = ", tam.moduleId);
              console.log("------------> add-project-modules-dialog checking tam: ", tam);
              const foundModule = modules.find(m => m.moduleId === tam.moduleId);
              if (foundModule) {
                // foundModule.count = tam.count;
                // foundModule.usedCount = tam.usedCount;
                console.log("------------> add-project-modules-dialog foundModule to update = ", foundModule);
              }
            });

            this.availableModules = modules;  
            // this.availableModules.forEach(m => {
            //   m.count = 0;
            //   m.usedCount = 0;
            //   m.isBooked = this.data.some(bm => bm.moduleId === m.moduleId);
            //   m.isDisabled = true;
            // });

            //console.log("-------> add-project-modules-dialog available modules after mark booked: ", this.availableModules)
            // if (this.data && this.data.length > 0) {
            //   this.data.forEach(bookedModule => {
            //     const foundModule = this.availableModules.find(m => m.moduleId === bookedModule.moduleId);
            //     if (foundModule) {
            //       // foundModule.count = bookedModule.count;
            //       // foundModule.usedCount = bookedModule.usedCount;
            //     } else {
            //       this.bookedModules.push(bookedModule);
            //     }
            //   });
            // }
            if (this.availableModules && this.availableModules.length > 0) {
              this.availableModules.forEach(availableModule => {
                if (availableModule.isConfigAlwaysVisible) {
                  const bookedModule = new BookedProjectModules(availableModule.moduleName, availableModule.moduleId,  "");
                  this.bookedModules.push(bookedModule);
                }
              });
            }
            this.data = this.bookedModules;
            console.log("------------> add-project-modules-dialog bookedModules = ", this.data);

            this.isModulesLoaded = true;
            this.createForm();

          },
          error: (error: any) => {
            //this.errorMessage = ErrorFormat.formatError(error);
            this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error getting tenant additional modules");
            if (error.error != null) {  
              this.notificationService.info("", error.error.developerMessage.Message)
            }
          }
        });


      },
        error: (error: any) => {
          this.notificationService.error(`${this.translate.data["ERROR"]}`, "Fehler beim Laden der verfügbaren Module");
          if (error.error != null) {
            this.notificationService.error(`${this.translate.data["ERROR"]}`, `${error.error}`);
          }
        }
    })           
  }

  createForm() {
    this.modulesForm = this.formBuilder.group({
      modules: this.formBuilder.array(
      this.data.map(m =>
      this.formBuilder.group({
      moduleName: [m.moduleName],
      moduleId: [m.moduleId],
      isBooked: [this.savedata.some(bm => bm.moduleId === m.moduleId)],
      wasBooked: [this.savedata.some(bm => bm.moduleId === m.moduleId)], //zum Vergleich ob gebucht vorher
      isDisabled: [
        // !this.tenantAvailableModules.some(
        // tam => (tam.count !== null && tam.count !== undefined && tam.count >0) ? tam.moduleId === m.moduleId && ((tam.count ?? 0) - (tam.usedCount ?? 0)) > 0 : 
        //                                                                                                                                     tam.moduleId !== m.moduleId
        // )
        !this.tenantAvailableModules.some(
          tam => tam.moduleId === m.moduleId && ((tam.count ?? 0) - (tam.usedCount ?? 0)) > 0
        )
        // !this.tenantAvailableModules.some(
        //   tam => tam.moduleId === m.moduleId && (tam.count === null || tam.count === undefined || (tam.count ?? 0) - (tam.usedCount ?? 0) > 0
        // )
        // !this.tenantAvailableModules.some(
        //   tam => tam.moduleId === m.moduleId
        // )
      ],
          // !this.tenantAvailableModules.some(
          //   tam => tam.moduleId === m.moduleId && ((tam.count ?? 0) - (tam.usedCount ?? 0)) > 0
          // )
            // usedCount: [m.usedCount ?? 0],
            // count: [
            //   m.count,
            //   [
            //     Validators.required,
            //     Validators.min(m.usedCount ?? 0)
            //   ]
            // ]
          })
        )
      )    
    });
   console.log("-------> add-project-modules-dialog created modules form: ", this.modulesForm.value)
  }

  cancel() {
      this._dialogRef.close(this.savedata);
      //this._dialogRef.close();
  }

  add() {
    //console.log("-------> add-tenant-modules-dialog before close data: ", this.modulesForm.value.modules)
    if (this.modulesForm.valid) {
      const filteredModules = this.modulesForm.value.modules.filter((m: any) => m.isBooked == true);
      //console.log("-------> add-project-modules-dialog filtered booked modules: ", filteredModules)
      const bookedModules: BookedProjectModules[] = [];

      filteredModules.forEach((m: any) => {
        const existingModule = this.savedata.find(dm => dm.moduleId === m.moduleId);
        if (m.isBooked) {
          const bookedModule = new BookedProjectModules(m.moduleName, m.moduleId,  existingModule ? existingModule.validUntil : "");
         bookedModules.push(bookedModule);
        }
      });
      //console.log("-------> add-project-modules-dialog booked modules to return: ", bookedModules)
      this._dialogRef.close(bookedModules);
      //this.notificationService.success(`${this.translate.data["SUCCESS"]}`, 'Module erfolgreich bearbeitet; Speichern nicht vergessen!');
    }
  }
}

